import declensionByNum from 'src/utils/declensionByNum'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

export default function formatServiceDuration(duration?: number | null): string {
  if (!duration) {
    return ''
  }

  const unit = declensionByNum(duration, [
    tStatic('минута'),
    tStatic('минуты'),
    tStatic('минут'),
  ])

  return `${duration} ${unit}`
}
